import React, { useState, useEffect } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Input,
  Label,
  Button,
  Form,
} from "reactstrap"
import { get, put } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { error } from "toastr"
import { Trans } from "react-i18next"
import { Link, Route, useNavigate, useParams } from "react-router-dom"
// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"
import Loader from "common/loader"
import { SHOW_USER, UPDATE_USER, ROLES } from "helpers/api_endpoints"
import Select from "react-select";

//meta title
document.title = "Edit User"

const EditUser = () => {
  const [loading, setLoading] = useState(true)
  const params = useParams()
  const [id, setid] = useState("")
  const [name, setname] = useState("")
  const [email, setemail] = useState("")
  const [password, setpassword] = useState("")
  const [mobile, setmobile] = useState("")
  const [roleId, setRoleId] = useState(null)
  const [roles, setRoles] = useState([])
  const [driverEmergencyNotification, setDriverEmergencyNotification] =
    useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    get(`${ROLES}`)
      .then(response => {
        const roles = response.data;
        setRoles(roles.map(el => {
          return { label: el.name, value: el.id }
        }));
        setLoading(false)
      })
      .catch(error => {
        navigate("/users")
      })

      get(`${SHOW_USER}/${params.id}`)
        .then(response => {
        const user = response.data
        setid(params.id)
        setemail(user.email)
        setname(user.name)
        setmobile(user.mobile)
        setRoleId(user.Roles[0]?.id)
        setDriverEmergencyNotification(!!user.driverEmergencyNotification)
        setLoading(false)
      })
      .catch(error => {
        navigate("/users")
      })
  }, [])

  const handleSubmit = () => {
    put(UPDATE_USER, {
      id,
      name,
      email,
      mobile,
      password,
      roleId,
      driverEmergencyNotification,
    })
      .then(response => {
        // console.log(response)
        if (response.code == 200) {
          navigate("/users", {
            state: { successMsg: "User Updated SuccessFully" },
          })
        }
      })
      .catch(error => {
        console.log(error.response)
      })
  }
  const handleCheckboxChange = event => {
    const newValue = !driverEmergencyNotification
    setDriverEmergencyNotification(newValue)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Users" breadcrumbItem="Edit User" />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    {loading ? (
                      <Loader></Loader>
                    ) : (
                      <Row>
                        <div className="form-group col-md-6 mt-2">
                          <Label className="form-label">
                            <Trans>Name</Trans>
                          </Label>
                          <Input
                            name="username"
                            value={name}
                            className="form-control"
                            placeholder="Enter User Name"
                            type="text"
                            onChange={e => setname(e.target.value)}
                            required
                          ></Input>
                          <Input type="hidden" name="id"></Input>
                        </div>

                        <div className="form-group col-md-6 mt-2">
                          <Label className="form-label">
                            <Trans>Email</Trans>
                          </Label>
                          <Input
                            name="email"
                            value={email}
                            className="form-control"
                            placeholder="Enter Email"
                            type="email"
                            onChange={e => setemail(e.target.value)}
                            required
                          ></Input>
                        </div>

                        <div className="form-group col-md-6 mt-2">
                          <Label className="form-label">
                            <Trans>Role</Trans>
                          </Label>
												<Select
													name="roleId"
                          options={roles}
                          value={roles.find(role => role.value == roleId)}
													className="form-control select2"
													onChange={(e) => setRoleId(e.value)}
													/>
                        </div>

                        <div className="form-group col-md-6 mt-2">
                          <Label className="form-label">
                            <Trans>Mobile</Trans>
                          </Label>
                          <Input
                            name="mobile"
                            type="tel"
                            value={mobile}
                            onChange={e =>
                              setmobile(e.target.value.replace(/\D/g, ""))
                            } // only digits
                            pattern="^(971|92)[0-9]{9}$"
                            title="Enter valid UAE (971xxxxxxxxx) or Pakistan (92xxxxxxxxx) mobile number"
                            required
                          ></Input>
                        </div>

                        <div className="form-group col-md-6 mt-2">
                          <Label className="form-label">
                            <Trans>Password</Trans>
                          </Label>
                          <Input
                            // name="name"
                            value={password}
                            className="form-control"
                            placeholder="Enter Password"
                            type="password"
                            onChange={e => setpassword(e.target.value)}
                          ></Input>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="form-group">
                            <Label className="form-label">
                              <Trans>Driver Emergency Notification</Trans>
                            </Label>
                            <div
                              className="form-check form-switch form-switch-lg"
                              dir="ltr"
                            >
                              <input
                                type="checkbox"
                                name="driverEmergencyNotification"
                                className="form-check-input"
                                id="driverEmergencyNotification"
                                checked={driverEmergencyNotification}
                                onClick={handleCheckboxChange}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="driverEmergencyNotification"
                              ></Label>
                            </div>
                          </div>
                        </div>
                        <div className="text-center  mt-4">
                          <Button type="submit" color="danger">
                            <Trans>Submit</Trans>
                          </Button>
                        </div>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditUser
